import React from "react";
import { Car } from "lucide-react";

/**
 * Mapa de asientos clickeable. `layout` viene de GET /api/asientos/layout/{capacidad}
 * (geometría fija por capacidad, ver backend/app/core/seat_layouts.py).
 * `takenSeats` son los seat_number ya ocupados en la salida elegida.
 * `selectedSeats` es lo que el usuario lleva elegido en este formulario.
 */
const SeatMap = ({ layout, takenSeats = [], selectedSeats = [], onToggleSeat, disabled = false }) => {
  if (!layout || layout.length === 0) return null;

  const maxRow = Math.max(...layout.map((s) => s.row));
  const maxCol = Math.max(...layout.map((s) => s.col));

  const byPosition = {};
  layout.forEach((seat) => {
    byPosition[`${seat.row}-${seat.col}`] = seat;
  });

  return (
    <div data-testid="seat-map">
      <div className="flex items-center justify-center gap-2 mb-4 text-[#A0A0A5]">
        <Car size={16} />
        <span className="text-[10px] uppercase tracking-wider font-display">Conductor</span>
      </div>
      <div
        className="grid gap-2 mx-auto w-fit"
        style={{ gridTemplateColumns: `repeat(${maxCol}, minmax(0, 44px))` }}
      >
        {Array.from({ length: maxRow }, (_, rowIdx) => rowIdx + 1).map((row) =>
          Array.from({ length: maxCol }, (_, colIdx) => colIdx + 1).map((col) => {
            const seat = byPosition[`${row}-${col}`];
            if (!seat) return <div key={`${row}-${col}`} />;

            const isTaken = takenSeats.includes(seat.seat_number);
            const isSelected = selectedSeats.includes(seat.seat_number);

            return (
              <button
                key={seat.seat_number}
                type="button"
                disabled={disabled || isTaken}
                onClick={() => onToggleSeat(seat.seat_number)}
                title={`Asiento ${seat.seat_number} · ${seat.label}`}
                data-testid={`seat-${seat.seat_number}`}
                className={`w-11 h-11 rounded-lg border text-xs font-display font-bold flex items-center justify-center transition-colors
                  ${
                    isTaken
                      ? "bg-[#2E2F33] border-[#2E2F33] text-[#5A5B60] cursor-not-allowed"
                      : isSelected
                        ? "bg-[#C9A227] border-[#C9A227] text-[#0D0E10]"
                        : "bg-[#0D0E10] border-[#2E2F33] text-[#F5F5F5] hover:border-[#C9A227]/50"
                  }`}
              >
                {seat.seat_number}
              </button>
            );
          })
        )}
      </div>
      <div className="flex items-center justify-center gap-5 mt-5 text-[10px] uppercase tracking-wider text-[#A0A0A5] font-display">
        <span className="flex items-center gap-1.5">
          <span className="w-3 h-3 rounded bg-[#0D0E10] border border-[#2E2F33] inline-block" /> Libre
        </span>
        <span className="flex items-center gap-1.5">
          <span className="w-3 h-3 rounded bg-[#C9A227] inline-block" /> Elegido
        </span>
        <span className="flex items-center gap-1.5">
          <span className="w-3 h-3 rounded bg-[#2E2F33] inline-block" /> Ocupado
        </span>
      </div>
    </div>
  );
};

export default SeatMap;
